import { configureStore } from '@reduxjs/toolkit'
import pageReducer from './reducers/pageManageReducer'
import docsReducer from './reducers/documentsReducers'
import verifyReducer from './reducers/userVerifyReducers'
import paymentsReducer from './reducers/paymentsReducers'
import advertisementsReducer from './reducers/advertisementsReducers'

const store = configureStore({
	reducer: {
		pageManage: pageReducer,
		documentsList: docsReducer,
		verify: verifyReducer,
        payments: paymentsReducer,
        advertisements: advertisementsReducer,
	},
})

export default store
